import React, { Component } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import de from 'date-fns/locale/de';
import { translate } from "react-i18next";
import '../../css/style.css';
import '../Home.css';
import { Form, Row, Col, Button, OverlayTrigger, Tooltip, Card, Alert } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import FileUpload from '../util/FileUpload';
import { deleteItem, sendJson, getURL, BACKEND_URL, TEMPORARY, ACTIVATED, DEACTIVATED, EVENT_IMG_URL } from '../../backend/Backend';
import { Redirect } from 'react-router-dom';
import { BOOKING_TYPES, PUB_CATEGORIES } from '../../backend/Data';
import { getTransValue } from "../../backend/UIUtils";
import i18n from "i18next";


import axios from 'axios';




registerLocale('de', de)

function emptyEventDetail() {
    return {
        startDate: new Date(), endDate: new Date(), eventCategory: '', title: 'XXX', comment: 'YYYY', commentsEnabled: '', location: '', limitParticipants: '', maxParticipants: '', limitDateChoose: '',
        publicEmail: '', publicPhoneNr: '', publicMobileNr: '', eventLink: '', bookingLink: '', useBookingService: '', mediaLink: '', videoLink: '', eventType: 'PUBLIC',
        locationName: '', street: '', zipcode: '', city: '', country: '', canton: '', file: null
    };
}

class PublicEventEditDetail extends Component {

    constructor(props) {
        super(props);
        this.onEventInputChange = this.onEventInputChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onEventStartDateChange = this.onEventStartDateChange.bind(this);
        this.onEventEndDateChange = this.onEventEndDateChange.bind(this);
        this.onFileChange = this.onFileChange.bind(this);
        this.saveEvent = this.saveEvent.bind(this);
        this.updateEventStatus = this.updateEventStatus.bind(this);
        this.cloneEvent = this.cloneEvent.bind(this);
        this.deleteEvent = this.deleteEvent.bind(this);
        this.removeImage = this.removeImage.bind(this);
        this.executeFileUpload = this.executeFileUpload.bind(this);

        
        this.state = {
            validated: false,
            event: emptyEventDetail(),
            message: '',
            redirectLink: '',
            selectedCat: null
        };
    }



    async componentDidMount() {
        let eventId = this.props.eventId ? this.props.eventId : '0';
        const response = await fetch(getURL(`p-events/load/${eventId}`));
        const loadedEvent = await response.json();
        let oldState = this.state;

        let selectedCat = null;
        if (loadedEvent.eventDetail && loadedEvent.eventDetail.eventCategory) {
            if ("0" === loadedEvent.eventDetail.eventCategory) {
                selectedCat = null;
            } else {
                let filteredcat = PUB_CATEGORIES.filter(cat => cat.code === loadedEvent.eventDetail.eventCategory);
                if (filteredcat && filteredcat.length > 0) {
                    selectedCat = filteredcat[0];
                }
            }
        }

        this.setState({
            ...oldState,
            event: loadedEvent.eventDetail,
            selectedCat: selectedCat
        });

    }


    handleChange(e) {

        const { event } = this.state;

        const newEvent = {
            ...event,
            [e.target.name]: e.target.checked
        };

        this.setState({
            event: newEvent
        });
    }

    onEventInputChange(obj) {
        const { name: fieldName, value: fieldValue } = obj.target;

        const { event } = this.state;
        let oldState = this.state;

        let selectedCat = this.state.selectedCat;
        if (obj.target.name === 'eventCategory') {
            if ("0" === obj.target.value) {
                selectedCat = null;
            } else {
                let filteredcat = PUB_CATEGORIES.filter(cat => cat.code === obj.target.value);
                if (filteredcat && filteredcat.length > 0) {
                    selectedCat = filteredcat[0];
                }
            }
        }


        const newEvent = {
            ...event,
            [fieldName]: fieldValue
        };
        console.log("newEvent" + JSON.stringify(newEvent))

        this.setState({
            ...oldState,
            event: newEvent,
            selectedCat: selectedCat
        });

    }

    onEventStartDateChange(choosed) {
        const { event } = this.state;

        const newEvent = {
            ...event,
            startDate: choosed !== null ? choosed.getTime() : '',
            endDate: choosed !== null && event.endDate === null ? choosed.getTime() : event.endDate
        };
        this.setState({
            event: newEvent
        });
    }

    onEventEndDateChange(choosed) {
        const { event } = this.state;

        const newEvent = {
            ...event,
            endDate: choosed !== null ? choosed.getTime() : ''
        };
        this.setState({
            event: newEvent
        });
    }

    onFileChange(file) {
        let oldEvent = this.state.event;

       /* const newEvent = {
            ...oldEvent,
            file: e.target.files[0]
        };*/
        this.executeFileUpload(file, this.props.eventId);

       /* this.setState({
            event: newEvent
        });*/
    }

    saveEvent(event) {
        //const { event } = this.state;
        sendJson('post', 'p-events/updateDetail', { "eventDetail": event }).then(
            received => {
                console.log("Saved updateDetail: " + JSON.stringify(received));

               
                let oldState = this.state;
                this.setState({
                    ...oldState,
                    message: 'successSaved'
                });
                setTimeout(() => this.setState({ ...oldState, message: '' }), 1000);
            });

    }

    removeImage(imageName){
        console.log("removeImage: "+ imageName);
        let path = 'storage/deleteFile/' + imageName+ "/" + this.props.eventId+"/2";
        

        fetch(getURL(path))
        .then((response) => {
          //this.props.removeComment(id);
          let oldState = this.state;
          let oldEvent = this.state.event;
          oldEvent.imageName = null;
          this.setState({
            ...oldState,
            event: oldEvent
        });
        })
        .catch((error) => {
          console.error(error);
        });
    
    }

    executeFileUpload(file, id) {
        if(!file){
          return;
        }
    
      
         console.log("executeFileUpload: "+file.name +" id:"+id);
         this.fileUpload(file, id, 2);
         let oldState = this.state;
         this.setState({
           ...oldState,
           message: 'fileUploaded'
         });
         setTimeout(() => this.setState({ ...oldState, message: '' }), 1000);
      }

      fileUpload(file, id, eventType) {
        if(!file){
          return;
        }
      
        let path = 'storage/uploadFile/' + id +"/"+eventType;
        const url = `${BACKEND_URL}${path}`;
      
        const formData = new FormData();
        formData.append('file', file);
        formData.append('name', file.name);
        const config = {
          headers: {
            'content-type': 'multipart/form-data'
          }
        }
         axios.post(url, formData, config)
         .then((fileName) => {
            if(fileName && fileName.data){
                let oldState = this.state;
                let oldEvent = this.state.event;
                oldEvent.imageName = fileName.data;
                this.setState({
                  ...oldState,
                  event: oldEvent
              });
            }
          
          })
          .catch((error) => {
            console.error(error);
          });
      }

    async cloneEvent() {
        const response = await fetch(getURL(`p-events/cloneevent/` + this.props.eventId));
        const json = await response.json();

        if (json.id) {
            let oldState = this.state;
            this.setState({
                ...oldState,
                redirectLink: "/pubEventClone/" + json.id
            });
        }
    }

    deleteEvent() {

        deleteItem('p-events', this.props.eventId).then(
            received => {
                if (received.ok) {
                    let oldState = this.state;
                    this.setState({
                        ...oldState,
                        message: 'successDeleted',
                        deleted: true
                    });
                    setTimeout(() => this.setState({ ...oldState, message: '' }), 1000);
                }
            });
    }


    updateEventStatus(eventStatus) {
        const { event } = this.state;

        const newEvent = {
            ...event,
            eventStatus: eventStatus
        };

        console.log("event limit changed:" + JSON.stringify(newEvent));

        this.setState({
            event: newEvent
        });
        //this.saveEvent(newEvent);

        let path = 'p-events/updateStatus/'+this.props.eventId+'/'+eventStatus ;
        

        fetch(getURL(path))
        .then((response) => {
          //this.props.removeComment(id);
          let oldState = this.state;
          let oldEvent = this.state.event;
          oldEvent.imageName = null;
          this.setState({
            ...oldState,
            event: oldEvent
        });
        })
        .catch((error) => {
          console.error(error);
        });

    }

   


    render() {
        if (this.state.redirectLink) {
            return <Redirect to={this.state.redirectLink} />
        }

        let lang = i18n.language;
        const { t } = this.props;
        const { event: { eventCategory, subCategory, title, startDate, endDate, description,imageName, userMinAge, maxParticipants, eventLink, bookingLink, file, locationName, street, zipcode, city, country, canton, bookingType } } = this.state;
 
        return (
            <div className=" justify-content-between d-relative mt-1  p-2 ">

                <Card className="mt-1 ">
                    <Card.Body className="greyBg">

                        <Row >
                            <Col lg={1} md={2}>
                                <Form.Label>{t("KategorienAuswahl")}</Form.Label>
                            </Col>
                            <Col lg={11} md={10}>
                                    <Row >
                                <Col lg={5} md={12}>
                                    <Form.Control as="select" name="eventCategory" value={eventCategory} onChange={this.onEventInputChange} defaultValue="0">
                                        <option value="0">{t("catChoose")}</option>
                                        {PUB_CATEGORIES.map(c =>
                                            <option value={c.code} key={c.code} label={getTransValue(c, lang)}></option>
                                        )}
                                    </Form.Control>
                                </Col>
                                <Col lg={5} md={12} >
                                    <Form.Control as="select" name="subCategory" value={subCategory} onChange={this.onEventInputChange}
                                        disabled={!this.state.selectedCat && !subCategory} >
                                        {!this.state.selectedCat ?
                                            <option value="0">{t("subCatChoose")}</option>
                                            :
                                            ''
                                        }

                                        {this.state.selectedCat ?
                                            this.state.selectedCat.subs.map(c =>
                                                <option value={c.code} key={c.code} label={getTransValue(c, lang)}></option>
                                            )
                                            : ''
                                        }
                                    </Form.Control>
                                </Col>
                            </Row>
                            </Col>
                        </Row>
                        <Row >
                            <Col lg={1} md={2}>
                                <Form.Label>{t("title")}</Form.Label>
                            </Col>
                            <Col lg={11} md={10}>
                                <Form.Control value={title}
                                    name="title"
                                    onChange={this.onEventInputChange}
                                    placeholder={t("eventTitle") + " - " + this.props.eventId}
                                    maxLength={250}
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={1} >
                                <Form.Label>{t("start")}</Form.Label>
                            </Col>
                            <Col lg={4} >
                                <DatePicker selected={startDate}
                                    onChange={this.onEventStartDateChange}
                                    placeholderText={t("Startdatum")}
                                    minDate={new Date()}

                                    showTimeSelect
                                    timeFormat="HH:mm"
                                    dateFormat="Pp"
                                    locale="de"
                                    className="form-control"
                                    id="Startdatum"
                                />
                            </Col>
                            <Col>&nbsp;</Col>
                            <Col lg={2} >
                                <Form.Label >{t("end")}</Form.Label>
                            </Col>
                            <Col lg={4} >
                                <DatePicker selected={endDate}
                                    onChange={this.onEventEndDateChange}
                                    placeholderText={t("endDatum")}
                                    minDate={new Date()}
                                    showTimeSelect
                                    timeFormat="HH:mm"
                                    dateFormat="Pp"
                                    locale="de"
                                    className="form-control"

                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={1} >
                                <Form.Label>{t("description")}</Form.Label>
                            </Col>
                            <Col lg={11} >
                                <Form.Control as="textarea" value={description}
                                    name="description" onChange={this.onEventInputChange}
                                    placeholder={t("eventDescription")}
                                    rows="5" maxLength={2000} />
                            </Col>
                        </Row>

                        <Row className="mt-1 mb-1">
                            <Col lg={1} >
                                    <Form.Label>{t("bild")}</Form.Label>
                            </Col>
                            {!imageName ? 
                            <Col lg={4} >
                                <FileUpload fileChanged={ this.onFileChange} />
                            </Col>
                            :
                            ''}
                            {imageName ? 
                            <Col lg={5} >
                                 <Card.Img variant="top" src={ EVENT_IMG_URL + imageName } style={{"width":"6rem"}} className="float-left"/>
                                 <Button variant="outline-primary" onClick={() => this.removeImage(imageName)} className="float-left ml-3 mt-2"><span className="fa fa-trash-alt ">&nbsp;{t("removeImage")}</span></Button>
 
                                </Col>
                                :
                                ''}
                           
                        </Row>
                        
                       </Card.Body>
                       </Card>
                       <Card className="mt-1 ">
                        <Card.Body className="greyBg">
                        <Row>
                            <Col lg={1} >
                                &nbsp;
                            </Col>
                            <Col lg={4} md={11}>
                                <Form.Group className="mt-2 " >
                                <Form.Label  >{t("eventLink")}</Form.Label>
                                <Form.Control placeholder={t("eventLink")}
                                    value={eventLink} name="eventLink"
                                    onChange={this.onEventInputChange} maxLength={250}/>
                                    </Form.Group>
                                    </Col>

                           
                           
                            <Col lg={5} md={11}>
                                <Form.Group className="mt-2" >
                                   <Form.Label>{t("userMinAge")}</Form.Label>
                                   <Form.Control value={userMinAge}
                                    type="number"
                                    min="1"
                                    step="1"
                                    name="userMinAge"
                                    onChange={this.onEventInputChange}
                                    placeholder={t("0")}
                                    id="userMinAge"
                                    style={{ width: "80px" }}
                                />
                                </Form.Group>
                                </Col>
                        </Row>
                        <Row>
                            <Col lg={1} >
                                &nbsp;
                            </Col>
                            <Col lg={4} md={11}>
                                <Form.Group className="mt-2 " >
                                    <Form.Label >{t("bookingService")} </Form.Label>
                                    <Form.Control as="select" name="bookingType" value={bookingType} onChange={this.onEventInputChange} aria-describedby="bookingHelpBlock">
                                        {BOOKING_TYPES.map((r, i) =>
                                            <option selected={bookingType === r.value} key={r.value} value={r.value}>{t(r.label)}</option>
                                        )}

                                    </Form.Control>
                                </Form.Group>

                            </Col>

                            <Col lg={5} md={11}>
                                <Form.Group className="mt-2" >
                                    <Form.Label htmlFor="maxParticipants">{t("maximal")}</Form.Label>
                                    <Form.Control value={maxParticipants}
                                        type="number"
                                        min="1"
                                        step="1"
                                        name="maxParticipants"
                                        onChange={this.onEventInputChange}
                                        id="maxParticipants"
                                        style={{ width: "80px" }}

                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={1} >
                                &nbsp;
                            </Col>
                            <Col lg={4} md={11}>
                                {bookingType === 'EXTERN' ?
                                  <Form.Group >
                                  <Form.Label >{t("bookingLink")} </Form.Label>
                                    <Form.Control placeholder={t("bookingLink")}
                                        value={bookingLink} name="bookingLink"
                                        onChange={this.onEventInputChange} maxLength={250} />
                                        </Form.Group>
                                    :
                                    ''
                                }
                                {bookingType === 'INTERN' ?
                                    <Form.Text id="bookingHelpBlock" muted>
                                        {t("internHelp")}
                                    </Form.Text>
                                    :
                                    ''
                                }
                                {bookingType === 'NONE' ?
                                    <Form.Text id="bookingHelpBlock" muted>
                                        {t("noneHelp")}
                                    </Form.Text>
                                    :
                                    ''
                                }
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                <Card className="mt-1 ">
                    <Card.Body className="greyBg">
                        <Row>
                            <Col lg={1} >
                                <Form.Label>{t("localname")}</Form.Label>
                            </Col>
                            <Col lg={11} >
                                <Form.Control placeholder={t("lokal")}
                                    value={locationName} name="locationName"
                                    onChange={this.onEventInputChange}
                                    maxLength={250}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={1} >
                                <Form.Label>{t("address")}</Form.Label>
                            </Col>
                            <Col lg={11} >
                                <Form.Control placeholder={t("strasse")}
                                    value={street} name="street"
                                    onChange={this.onEventInputChange} maxLength={250}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={1} >
                                &nbsp;
                            </Col>

                            <Col lg={2} xs={6}>
                                <Form.Control placeholder={t("plz")}
                                    value={zipcode} name="zipcode"
                                    onChange={this.onEventInputChange} maxLength={10}/>
                            </Col>
                            <Col lg={4} xs={4} >
                                <Form.Control placeholder={t("ort")}
                                    value={city} name="city"
                                    onChange={this.onEventInputChange} maxLength={50}/>
                            </Col>

                        </Row>
                        <Row>
                            <Col lg={1} >
                                &nbsp;
                            </Col>

                            <Col lg={2} xs={6}>
                                <Form.Control placeholder={t("kanton")}
                                    value={canton} name="canton"
                                    onChange={this.onEventInputChange} maxLength={50} />
                            </Col>
                            <Col lg={4} xs={4} >
                                <Form.Control placeholder={t("land")}
                                    value={country} name="country"
                                    onChange={this.onEventInputChange} />
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                <Row>
                    <Col lg={12} md={12}>
                        <OverlayTrigger
                            key="top"
                            placement="top"
                            overlay={
                                <Tooltip id={`tooltip-top`}>
                                    {t("speichern")}
                                </Tooltip>
                            }>
                            <Button variant="outline-primary" onClick={() => this.saveEvent(this.state.event)} className="float-right mt-3"><span className="fa fa-save ">&nbsp;{t("speichern")}</span></Button>
                        </OverlayTrigger>

                        <OverlayTrigger
                            key="top"
                            placement="top"
                            overlay={
                                <Tooltip id={`tooltip-top`}>
                                    {t("eventLoeschen")}
                                </Tooltip>
                            }>
                            <Button variant="outline-primary" onClick={() => this.deleteEvent()} className="float-left mr-2 mt-3" disabled={this.state.deleted}><span className="fa fa-trash ">&nbsp;{t("eventLoeschen")}</span></Button>
                        </OverlayTrigger>
                        {
                            (this.state.event.eventStatus === TEMPORARY) ? (<OverlayTrigger
                                key="top"
                                placement="top"
                                overlay={
                                    <Tooltip id={`tooltip-top`}>
                                        {t("finish")}
                                    </Tooltip>
                                }>
                                <Button variant="outline-primary" onClick={() => this.updateEventStatus(ACTIVATED)} className="float-right mr-2 mt-3"><span className="fa fa-ban ">&nbsp;{t("finish")}</span></Button>
                            </OverlayTrigger>) : ''
                        }
                        {
                            (this.state.event.eventStatus !== TEMPORARY && this.state.event.eventStatus !== DEACTIVATED) ? (<OverlayTrigger
                                key="top"
                                placement="top"
                                overlay={
                                    <Tooltip id={`tooltip-top`}>
                                        {t("eventDeactivate")}
                                    </Tooltip>
                                }>
                                <Button variant="outline-primary" onClick={() => this.updateEventStatus(DEACTIVATED)} className="float-right mr-2 mt-3" disabled={this.state.deleted} ><span className="fa fa-ban ">&nbsp;{t("eventDeactivate")}</span></Button>
                            </OverlayTrigger>) : ''
                        }
                        {
                            (this.state.event.eventStatus === DEACTIVATED) ? (<OverlayTrigger
                                key="top"
                                placement="top"
                                overlay={
                                    <Tooltip id={`tooltip-top`}>
                                        {t("eventActivate")}
                                    </Tooltip>
                                }>
                                <Button variant="outline-primary" onClick={() => this.updateEventStatus(ACTIVATED)} className="float-right mr-2 mt-3" disabled={this.state.deleted} ><span className="fa fa-ban ">&nbsp;{t("eventActivate")}</span></Button>
                            </OverlayTrigger>) : ''
                        }



                    </Col>
                </Row>

                {this.state.message ?
                    <Alert variant="info">
                        {t(this.state.message)}
                    </Alert>
                    :
                    ''
                }
            </div>
        )
    }
}

export default translate("translations")(PublicEventEditDetail);
